// extracted by mini-css-extract-plugin
export default {"firstBlock":"tfL2OtAC","glavnoe":"A45jk0kv","news":"FStkr9_b","link":"vVg5ofIw"};